import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    accountingIntegrations: 'Accounting integrations',
    back: 'Back',
    expenseManagement: 'Expense Management',
    frenchIban: 'French IBAN',
    included: 'Included in all Shine plan',
    invoicesAndQuotes: 'Invoices and quotes',
    recommendedTag: 'Recommended for you',
    transactionExport: 'Transaction export',
    webAndMobileAccess: 'Web and mobile access',
  },
  fr: {
    accountingIntegrations: 'Intégrations comptable',
    back: 'Précédent',
    expenseManagement: 'Gestion facile des reçus',
    frenchIban: 'IBAN français',
    included: 'Inclus dans tous les abonnements Shine',
    invoicesAndQuotes: 'Création de devis et factures',
    recommendedTag: 'Recommandé pour vous',
    transactionExport: 'Exports illimités de vos transactions',
    webAndMobileAccess: 'Accès mobile et web',
  },
} as const);
